if (!customElements.get('product-add-to-cart-sticky')) {
class ProductAddToCartSticky extends HTMLElement {
    constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.sectionId = this.dataset.section;
    }

    isCartOpen() {
        const cartDrawer = document.querySelector('cart-drawer');
        return document.body.classList.contains('overflow-hidden') ||
            (cartDrawer && !cartDrawer.classList.contains('disabled'));
    }

    syncVariantIdFromMainForm() {
        const mainInput = document.querySelector(`#MainProduct-${this.sectionId} [name="id"]`)
            || document.querySelector(`#product-form-${this.sectionId} [name="id"]`)
            || document.querySelector(`product-info [name="id"]`);
        if (mainInput && mainInput.value && this.stickyAtcVariantInput) {
            this.stickyAtcVariantInput.value = mainInput.value;
        }
    }

    connectedCallback() {
        this.targetElement = document.querySelector('[id^="ProductSubmitButton-"]');
        this.footerElement = document.querySelector('footer');
        this.stickyAtcVariantInput = this.querySelector('.product-variant-id');

        window.addEventListener("scroll", this.handleScroll);
        document.body.addEventListener('change', this.handleVariantChange);

        // FIX PRIMARIO: sync hidden variant input justo antes del submit
        const stickyForm = this.querySelector('form');
        if (stickyForm) {
            stickyForm.addEventListener('submit', () => {
                this.syncVariantIdFromMainForm();
            }, true);
        }
        const stickyBtn = this.querySelector('button[name="add"]');
        if (stickyBtn) {
            stickyBtn.addEventListener('click', () => {
                this.syncVariantIdFromMainForm();
            }, true);
        }

        // FIX SECUNDARIO: PubSub variantChange (cubre el caso estándar Dawn)
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
            this._unsubVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (!event || !event.data) return;
                if (String(event.data.sectionId) !== String(this.sectionId)) return;
                const variantId = event.data.variant && event.data.variant.id;
                if (variantId != null && this.stickyAtcVariantInput) {
                    this.stickyAtcVariantInput.value = variantId;
                }
            });
        }

        // Interceptar click en cualquier botón ATC como seguro extra (existente)
        document.querySelectorAll('[name="add"]').forEach(btn => {
            btn.addEventListener('click', () => {
                setTimeout(() => {
                    if (this.isCartOpen()) {
                        this.classList.remove('show');
                    }
                }, 300);
            });
        });

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            this._cartObserver = new MutationObserver(() => {
                if (this.isCartOpen()) {
                    this.classList.remove('show');
                    this.style.setProperty('opacity', '0', 'important');
                    this.style.setProperty('visibility', 'hidden', 'important');
                    this.style.setProperty('pointer-events', 'none', 'important');
                } else {
                    this.style.removeProperty('opacity');
                    this.style.removeProperty('visibility');
                    this.style.removeProperty('pointer-events');
                    this.handleScroll();
                }
            });
            this._cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
        }

        this._bodyObserver = new MutationObserver(() => {
            if (this.isCartOpen()) {
                this.classList.remove('show');
                this.style.setProperty('opacity', '0', 'important');
                this.style.setProperty('visibility', 'hidden', 'important');
                this.style.setProperty('pointer-events', 'none', 'important');
            } else {
                this.style.removeProperty('opacity');
                this.style.removeProperty('visibility');
                this.style.removeProperty('pointer-events');
                this.handleScroll();
            }
        });
        this._bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    disconnectedCallback() {
        window.removeEventListener("scroll", this.handleScroll);
        document.body.removeEventListener('change', this.handleVariantChange);
        if (this._cartObserver) this._cartObserver.disconnect();
        if (this._bodyObserver) this._bodyObserver.disconnect();
        if (this._unsubVariantChange) this._unsubVariantChange();
    }

    getAbsoluteTop(element) {
        let top = 0;
        while (element) {
            top += element.offsetTop || 0;
            element = element.offsetParent;
        }
        return top;
    }

    handleScroll() {
        if (this.isCartOpen()) {
            this.classList.remove('show');
            return;
        }

        const targetTopPosition = this.getAbsoluteTop(this.targetElement);
        const footerTopPosition = this.getAbsoluteTop(this.footerElement);
        const isTargetElementOutOfView = targetTopPosition < window.scrollY;
        const isFooterInView = window.scrollY + window.innerHeight > footerTopPosition;

        if (isTargetElementOutOfView && !isFooterInView) {
            this.classList.add('show');
        } else {
            this.classList.remove('show');
        }
    }

    updateStickyATCOption(optionName, optionValue) {
        const matches = optionName.match(/options\[(.+)\]/);
        if (matches && matches[1]) optionName = matches[1];
        const optionDisplay = this.querySelector('.selected-variant-option[data-option-name="' + optionName + '"]');
        if (optionDisplay) optionDisplay.textContent = optionName + ': ' + optionValue;
    }

    handleVariantChange(event) {
        const target = event.target;
        const productSection = target.closest(`#MainProduct-${this.sectionId}`);
        if (!productSection) return;
        if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
            const optionName = target.name;
            const optionValue = target.tagName === 'INPUT' ? target.value : target.options[target.selectedIndex].textContent;
            this.updateStickyATCOption(optionName, optionValue);
        }
        // Sync también el variantId hidden (defensa en profundidad)
        this.syncVariantIdFromMainForm();
    }
}

customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}